import { ChatbotRest } from "@/services/rest/chatbot.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { getItemStorage } from "@/utils/save-storage.util";
import { getUserFromStorage } from "@/utils/user-store.util";
import { Observable } from "rxjs";
import { QuestionType } from "./chatbot.utils";

export class ChatBotService {
  constructor() {
    this.authWS();
    this.authWSActions();
  }

  private idCourseLocal: any = JSON.parse(getItemStorage("courseID") as string);
  private quizData: any = JSON.parse(getItemStorage("quizData") as string);

  initAuth(): string {
    var auth = JSON.stringify({
      jwt: getUserFromStorage()?.accessToken,
      course: this.idCourseLocal,
      quiz: this.quizData?.quiz ?? undefined,
      question: this.quizData?.question ?? undefined,
    });
    return auth;
  }

  removeTags(str: string): string {
    return str.replace(/(<([^>]+)>)/gi, "");
  }

  authWS(): void {
    ChatbotRest.ws.next(this.initAuth());
  }

  wsMessages(): Observable<any> {
    return ChatbotRest.websocketChatbot();
  }

  sendTextMessage(text: string, action: string = ""): void {
    ChatbotRest.ws.next(
      JSON.stringify({
        sender: {
          course_id: this.idCourseLocal,
          jwt: getUserFromStorage()?.accessToken,
        },
        action: action,
        message: this.removeTags(text),
      })
    );
  }

  answerOpenQuestion(blob: Blob, question: string, action: string): void {
    blob.arrayBuffer().then((buffer) => {
      let encoder = new TextEncoder().encode("open_questions_random");
      let key = new Uint8Array(encoder.buffer);
      let a1 = new Uint8Array([0x1, key.length]);
      let a2 = new Uint8Array(buffer);
      let concat = new Uint8Array([...a1, ...key, ...a2]);
      this.sendBlobMessage(new Blob([concat.buffer]));
    });
  }

  sendBlobMessage(blob: Blob): void {
    ChatbotRest.ws.next(blob);
  }

  authWSActions(): void {
    ChatbotRest.wsActions.next(this.initAuth());
  }

  wsMessagesActions(): Observable<any> {
    return ChatbotRest.websocketActions();
  }

  sendAudioActions(audio: Blob): void {
    ChatbotRest.wsActions.next(audio);
  }

  getStartMessage(firstName: string): string {
    return `
    <div class='space-y-4'>
      <p>
        ${GenericsUtils.translateI18n("chat.hello")} 
        ${firstName}, 
        ${GenericsUtils.translateI18n("chat.help")} 
      </p>
    </div><br>
    ${GenericsUtils.translateI18n("chat.start")}`;
  }

  getSpeechBubbleMessage(
    typeSpeechBubble: string,
    firstName: string,
    msg: string
  ): string {
    return `
    <div>
      <p class='font-bold'>${
        typeSpeechBubble === QuestionType.QUESTION_RANDOM ||
        typeSpeechBubble === QuestionType.QUESTION_WRONG
          ? GenericsUtils.translateI18n("chat.reviewingContent")
          : GenericsUtils.translateI18n("chat.hello") + firstName
      }</p> <br>
      ${msg}
    </div>`;
  }
}
